import React from 'react';
import AceLogo from '../../components/AceLogo/AceLogo';
import './AuthLayout.css';

export default function AuthLayout({ title, children, footer, wide }) {
  return (
    <div className="ace-auth-layout">
      <div className={`ace-auth-layout__inner${wide ? ' ace-auth-layout__inner--wide' : ''}`}>
        <div className="ace-auth-layout__brand">
          <AceLogo width={56} />
        </div>
        {title ? <h1 className="ace-auth-layout__title">{title}</h1> : null}
        <div className="ace-auth-layout__card">{children}</div>
        {footer ? <div className="ace-auth-layout__footer">{footer}</div> : null}
      </div>
    </div>
  );
}
